// import classNames from "classnames";

import { CardContainer } from "features/Strategy/v2/Detail/StrategyDetails.styles";
import { Title } from "style/components/Title.styles";
import PropTypes from "prop-types";

// import {
//   profile1,
//   profile2,
//   profile3,
//   profile4,
//   profile5,
// } from "assets/icons/strategy";

// const Profiles = [profile1, profile2, profile3, profile4, profile5];

const Community = ({ strategyName = "this strategy" }) => {
  return (
    <CardContainer className="secondary community d-none">
      <Title className="title mb-0">Community (coming soon!)</Title>
      <div className="divider"></div>
      <p>People you follow who use {strategyName}</p>
      {/*
      <div className="d-flex">
        {Profiles.map((profile, inx) => (
          <div key={inx} className="img-wrapper">
            <img
              src={profile}
              className={classNames({
                override: inx !== 0,
                last: inx === Profiles.length - 1,
              })}
            />
            {inx === Profiles.length - 1 && <div className="count">+15</div>}
          </div>
        ))}
      </div> */}
    </CardContainer>
  );
};

Community.propTypes = {
  strategyName: PropTypes.string,
};

export default Community;
